module.exports = __webpack_public_path__ + "static/img/empty-canister_256.9e79d1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty-canister_256.png
// module id = mAg9
// module chunks = 0